import { render, staticRenderFns } from "./SequencingNavbar.vue?vue&type=template&id=0b8a8d58&"
import script from "./SequencingNavbar.vue?vue&type=script&lang=js&"
export * from "./SequencingNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports